import React from "react";
import { Slider } from "antd";
import { clamp } from "../../utils/chart";

export function SliderDisplay({ label, value, minLabel, maxLabel, onChange }) {
  const safeValue = clamp(Number(value) || 0, 0, 100);

  return (
    <div>
      <div className="slider-row">
        <div className="slider-label">{label}</div>

        <div style={{ flex: 1 }} className="slider-div">
          <Slider
            className="display-slider"
            min={0}
            max={100}
            step={1}
            value={safeValue}
            tooltip={{ open: false }}
            onChange={onChange}
          />

          <div className="slider-scale">
            <span>{minLabel}</span>
            <span>{maxLabel}</span>
          </div>
        </div>

        <div className="slider-value">{safeValue}</div>
      </div>
    </div>
  );
}

export default SliderDisplay;
